module.exports = __webpack_public_path__ + "img/hr_co.1f7ee1a2.png";